module.exports = __webpack_public_path__ + "static/media/t-image1.a82675e7.jpg";